import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notification-modal',
  standalone: true,
  imports: [],
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
      <button type="button" class="btn close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row pt-3 m-3 fw-bold font-18">
        {{ message }}
      </div>
    </div>
    <!-- <div class="modal-footer my-3">
      <button
        (click)="activeModal.close(false)"
        type="submit"
        class="btn btn-footer"
      >
        Chiudi
      </button>
    </div> -->
  `,
  styleUrls: ['./notification-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationModalComponent {
  activeModal = inject(NgbActiveModal);

  @Input() title;

  @Input() message;
}
